import store, { state } from '@/store';

export default class Basket {
  basketKey = () => btoa('basket');

  addItemToBasket = (id, name, price, quantity = 1) => {
    localStorage.removeItem(this.basketKey());
    const tempBasket = Object.assign(state.basket);
    if (tempBasket[id]) {
      tempBasket[id].quantity += quantity;
    } else {
      tempBasket[id] = {
        name,
        quantity,
        price,
      };
    }

    localStorage.setItem(this.basketKey(), JSON.stringify(tempBasket));
    store.commit('updateBasket', tempBasket);
  }

  increaseItemInBasket = (productId) => {
    const tempBasket = state.basket;
    tempBasket[productId].quantity += 1;
    localStorage.setItem(this.basketKey(), JSON.stringify(tempBasket));
    store.commit('updateBasket', tempBasket);
  }

  decreaseItemInBasket = (productId) => {
    const tempBasket = state.basket;
    tempBasket[productId].quantity -= 1;
    if (tempBasket[productId].quantity === 0) {
      delete tempBasket[productId];
    }
    localStorage.setItem(this.basketKey(), JSON.stringify(tempBasket));
    store.commit('updateBasket', tempBasket);
  }

  removeItemFromBasket = (productId) => {
    const tempBasket = state.basket;
    delete tempBasket[productId];

    localStorage.setItem(this.basketKey(), JSON.stringify(tempBasket));
    store.commit('updateBasket', tempBasket);
  }

  clearBasket = () => {
    localStorage.removeItem(this.basketKey());
    store.commit('updateBasket', {});
  }
}
